import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '../../models/user.model';
import { images } from '../../data/image';

@Component({
  standalone: false,
  selector: 'app-player-item',
  templateUrl: './player-item.component.html',
  styleUrls: ['./player-item.component.scss'],
})
export class PlayerItemComponent {
  @Input() user: User;
  @Input() showApprove: boolean = false;
  @Output() onPrimary = new EventEmitter<void>();
  @Input() primaryText: string;
  @Input() isOwner: boolean = false;
  public avatarImage = images.avatarImage;

  constructor() { }

  getSex() {
    if (this.user.biographicalInformation) {
      if (this.user.biographicalInformation.sex === 'M') return 'Male';
      else return 'Female';
    }
  }

  onPrimaryClick(event: Event) {
    event.stopPropagation(); 
    this.onPrimary.emit();
  }

}
